import { gql, useLazyQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseLazyQuery } from '@/lib/apollo/types'

const getAccountantRefereeQuery = gql`
  query ($customerId: String!, $subjectId: String!) {
    getAccountantReferee(customerId: $customerId, subjectId: $subjectId) {
      id
      applicationId
      customerId
    }
  }
`

export type QueryVars = {
  customerId: string
  subjectId: string
}

export type AccountantReferee = {
  id: string
  applicationId: string
  customerId: string
}

export type GetAccountantRefereeData = {
  getAccountantReferee: AccountantReferee
}

export const useGetAccountantRefereeQuery: WrappedUseLazyQuery<
  GetAccountantRefereeData,
  QueryVars
> = options =>
  useLazyQuery<GetAccountantRefereeData, QueryVars>(getAccountantRefereeQuery, {
    ...options,
    client: agentClient,
  })
